import React from 'react';
import '../styles/totd.css';

export default function Totd({title, html }) {
		return (
			<div className='boundingBox'>
				<h4>Tip of the day!</h4>
				<h2>{title}</h2>
				<div
					className = 'totd-content'
					dangerouslySetInnerHTML = {{ __html: html }}
				/>
			</div>
	);
}

export const totdFragment = graphql`
	query Totd {
		markdownRemark {
			html
		}
	}
`
;


// WEBPACK FOOTER //
// ./src/components/Totd.js